import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  className: "empty"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "hint"
};
import empty from "@/images/empty.png";
export default {
  __name: 'index',
  props: ["text"],
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("img", {
        className: "img",
        src: _unref(empty)
      }, null, 8, _hoisted_2), _createElementVNode("div", _hoisted_3, _toDisplayString(__props.text), 1)]);
    };
  }
};